import { GLoading } from 'components/basic-blocks'
import { useUrlQuery } from 'hooks'
import { useEffect } from 'react'
import { AdAccountLinks } from 'services/user/ad-account-links'

export function FacebookOAuthPage() {
	const query = useUrlQuery()

	useEffect(() => {
		;(async () => {
			const token =
				query.long_lived_token || query.access_token || query['#access_token']
			const reAuth = window.localStorage.getItem('facebook-reauth')
			if (reAuth) {
				const accountId = window.localStorage.getItem('account-id')
				const linkId = window.localStorage.getItem('link-id')

				await AdAccountLinks.createOAuthLink('facebook', { auth_code: token }, accountId)

				if (linkId && accountId) await AdAccountLinks.syncLink(accountId, linkId)

				window.localStorage.removeItem('account-id')
				window.localStorage.removeItem('facebook-reauth')
				window.localStorage.removeItem('link-id')
			}
			window.localStorage.setItem('facebook_oauth_long_lived_token', token)
			if (window && window.opener)
				window.opener.dispatchEvent(new Event('beforeunload'))
			window.close()
		})()
	}, [])

	return (
		<div className="w-full h-full flex items-center justify-center">
			<GLoading />
		</div>
	)
}
